// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MemberItem Styles */

.member-item {
  display: flex;
  align-items: center;
  padding: 0;
  border-radius: 12px;
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-600);
  box-shadow: 0 2px 4px rgba(45, 31, 16, 0.1);
  transition: all 0.2s ease;
  overflow: visible;
}

.member-item--confirmed {
  border-color: var(--color-wood-800);
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
}

.member-item--pending {
  border-color: var(--color-warning-600);
  background:
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 4px,
      rgba(249, 168, 37, 0.12) 4px,
      rgba(249, 168, 37, 0.12) 6px
    ),
    linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);
  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);
}

.member-item--empty {
  padding: 12px 16px;
  background: var(--color-wood-50);
  border-color: var(--color-wood-500);
  border-style: dashed;
  color: var(--color-text-secondary);
  box-shadow: none;
  gap: var(--space-3);
}

.member-item--joinable {
  cursor: pointer;
}

.member-item--joinable:hover {
  background: linear-gradient(135deg, #e8f5ea 0%, #d4ead6 100%);
  border-color: var(--color-nature-700);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 124, 89, 0.3);
}

.member-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(109, 76, 41, 0.15);
  border-radius: 50%;
  border: 2px solid var(--color-wood-700);
  color: #4caf50;
  font-weight: 900;
}

.member-icon--empty {
  background: transparent;
  border: none;
  color: var(--color-wood-600);
}

/* Avatar with status badge */
.mi-avatar-wrap {
  position: relative;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  align-self: center;
  margin-left: 8px;
}

.mi-avatar-wrap::after {
  content: '';
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid var(--color-parchment-100);
  z-index: 1;
  display: none;
}

.mi-avatar-wrap--confirmed::after {
  display: block;
  background: #4caf50;
}

.mi-avatar-wrap--pending::after {
  display: block;
  background: #f9a825;
  animation: pulse-badge 1.8s ease-in-out infinite;
}

@keyframes pulse-badge {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}

.mi-avatar {
  width: 32px;
  height: 32px;
  line-height: 0;
}

.mi-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 2px solid var(--color-wood-600);
}

.mi-avatar .member-avatar-placeholder {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-wood-300, #c4a570);
  border: 2px solid var(--color-wood-600);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--color-wood-800, #5a3e1b);
  font-weight: 700;
}

/* Role badge — inline icon between avatar and name */
.mi-role-badge {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 1;
  border: 1.5px solid var(--color-parchment-100);
  margin: 0 5px;
}

.mi-key-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border: 1.5px solid var(--color-wood-800);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 1;
}

.mi-role-badge--organizer {
  background: linear-gradient(135deg, #d4a017, #c49000);
  box-shadow: 0 1px 3px rgba(180, 140, 20, 0.5);
}

.mi-role-badge--admin {
  background: linear-gradient(135deg, #8b2252, #6e1a40);
  box-shadow: 0 1px 3px rgba(110, 26, 64, 0.5);
}

.mi-role-badge--user {
  background: var(--color-wood-500, #8a6d3b);
  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.4);
}

/* Content area — name + actions with padding */
.mi-content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 10px 16px 10px 0;
}

.member-name {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-family: var(--font-body);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.member-info .member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.member-reserved-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.member-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.member-action-btn {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-wood-900);
  background: #c4a570;
  border: 2px solid var(--color-wood-700);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-heading);
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.member-action-icon {
  display: none;
}

.member-action-btn:hover {
  background: var(--color-danger-100);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);
}

.member-action-btn--confirm {
  color: var(--color-nature-900);
  border-color: var(--color-nature-500);
  background: #268d49;
  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);
}

.member-action-btn--confirm:hover {
  background: #166b32;
  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);
}

.member-action-btn--leave {
  border-color: var(--color-wood-700);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
}

.member-action-btn--leave:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
}

/* Remove member button */
.member-remove-btn {
  width: 28px;
  height: 28px;
  margin-left: auto;
  border-radius: 50%;
  border: 2px solid #8b2e0b;
  background: linear-gradient(135deg, #c53030, #a02020);
  color: #ffffff;
  font-size: 18px;
  font-weight: 900;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}

.member-remove-btn:hover {
  background: linear-gradient(135deg, #a02020, #8b1a1a);
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.member-remove-btn:active {
  transform: scale(0.95);
}

/* Mobile responsive */
@media (max-width: 425px) {
  .member-item {
    border-width: 1px;
    border-radius: 10px;
  }

  .member-item--empty {
    padding: 8px 10px;
  }

  .member-icon {
    width: 22px;
    height: 22px;
    font-size: 16px;
    border-width: 1px;
  }

  .mi-avatar-wrap {
    width: 32px;
    height: 32px;
    margin-left: 6px;
  }

  .mi-avatar-wrap::after {
    width: 9px;
    height: 9px;
  }

  .mi-role-badge {
    width: 22px;
    height: 22px;
    font-size: 12px;
    margin: 0 4px;
  }

  .mi-key-icon {
    width: 22px;
    height: 22px;
  }

  .mi-avatar,
  .mi-avatar img,
  .mi-avatar .member-avatar-placeholder {
    width: 32px;
    height: 32px;
  }

  .mi-avatar .member-avatar-placeholder {
    font-size: 12px;
  }

  .mi-content {
    gap: 8px;
    padding: 8px 10px 8px 0;
  }

  .member-name {
    font-size: 13px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
  }

  .member-actions {
    gap: 6px;
  }

  .member-action-btn {
    width: 24px;
    height: 24px;
    padding: 0;
    font-size: 12px;
    border-width: 1px;
    border: 2px solid #217021;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(109, 76, 41, 0.25);
    flex: 0 0 auto;
  }

  .member-action-text {
    display: none;
  }

  .member-action-icon {
    display: inline-block;
    line-height: 1;
  }

  .member-remove-btn {
    width: 24px;
    height: 24px;
    font-size: 14px;
    border-width: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/members/MemberItem.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,sCAAsC;EACtC,uCAAuC;EACvC,2CAA2C;EAC3C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC;;;;;;;;qDAQmD;EACnD,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA,+CAA+C;AAC/C;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,6CAA6C;IAC7C,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* MemberItem Styles */\n\n.member-item {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border-radius: 12px;\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-600);\n  box-shadow: 0 2px 4px rgba(45, 31, 16, 0.1);\n  transition: all 0.2s ease;\n  overflow: visible;\n}\n\n.member-item--confirmed {\n  border-color: var(--color-wood-800);\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n}\n\n.member-item--pending {\n  border-color: var(--color-warning-600);\n  background:\n    repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 4px,\n      rgba(249, 168, 37, 0.12) 4px,\n      rgba(249, 168, 37, 0.12) 6px\n    ),\n    linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);\n  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);\n}\n\n.member-item--empty {\n  padding: 12px 16px;\n  background: var(--color-wood-50);\n  border-color: var(--color-wood-500);\n  border-style: dashed;\n  color: var(--color-text-secondary);\n  box-shadow: none;\n  gap: var(--space-3);\n}\n\n.member-item--joinable {\n  cursor: pointer;\n}\n\n.member-item--joinable:hover {\n  background: linear-gradient(135deg, #e8f5ea 0%, #d4ead6 100%);\n  border-color: var(--color-nature-700);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 124, 89, 0.3);\n}\n\n.member-icon {\n  font-size: 20px;\n  line-height: 1;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(109, 76, 41, 0.15);\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-700);\n  color: #4caf50;\n  font-weight: 900;\n}\n\n.member-icon--empty {\n  background: transparent;\n  border: none;\n  color: var(--color-wood-600);\n}\n\n/* Avatar with status badge */\n.mi-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  align-self: center;\n  margin-left: 8px;\n}\n\n.mi-avatar-wrap::after {\n  content: '';\n  position: absolute;\n  right: -1px;\n  bottom: -1px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1.5px solid var(--color-parchment-100);\n  z-index: 1;\n  display: none;\n}\n\n.mi-avatar-wrap--confirmed::after {\n  display: block;\n  background: #4caf50;\n}\n\n.mi-avatar-wrap--pending::after {\n  display: block;\n  background: #f9a825;\n  animation: pulse-badge 1.8s ease-in-out infinite;\n}\n\n@keyframes pulse-badge {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n}\n\n.mi-avatar {\n  width: 32px;\n  height: 32px;\n  line-height: 0;\n}\n\n.mi-avatar img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n  border: 2px solid var(--color-wood-600);\n}\n\n.mi-avatar .member-avatar-placeholder {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--color-wood-300, #c4a570);\n  border: 2px solid var(--color-wood-600);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: var(--color-wood-800, #5a3e1b);\n  font-weight: 700;\n}\n\n/* Role badge — inline icon between avatar and name */\n.mi-role-badge {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  line-height: 1;\n  border: 1.5px solid var(--color-parchment-100);\n  margin: 0 5px;\n}\n\n.mi-key-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-right: 5px;\n  border: 1.5px solid var(--color-wood-800);\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  line-height: 1;\n}\n\n.mi-role-badge--organizer {\n  background: linear-gradient(135deg, #d4a017, #c49000);\n  box-shadow: 0 1px 3px rgba(180, 140, 20, 0.5);\n}\n\n.mi-role-badge--admin {\n  background: linear-gradient(135deg, #8b2252, #6e1a40);\n  box-shadow: 0 1px 3px rgba(110, 26, 64, 0.5);\n}\n\n.mi-role-badge--user {\n  background: var(--color-wood-500, #8a6d3b);\n  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.4);\n}\n\n/* Content area — name + actions with padding */\n.mi-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 10px 16px 10px 0;\n}\n\n.member-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-family: var(--font-body);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.member-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.member-info .member-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.member-reserved-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.member-actions {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.member-action-btn {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--color-wood-900);\n  background: #c4a570;\n  border: 2px solid var(--color-wood-700);\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--font-heading);\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.member-action-icon {\n  display: none;\n}\n\n.member-action-btn:hover {\n  background: var(--color-danger-100);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);\n}\n\n.member-action-btn--confirm {\n  color: var(--color-nature-900);\n  border-color: var(--color-nature-500);\n  background: #268d49;\n  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);\n}\n\n.member-action-btn--confirm:hover {\n  background: #166b32;\n  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);\n}\n\n.member-action-btn--leave {\n  border-color: var(--color-wood-700);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n}\n\n.member-action-btn--leave:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n}\n\n/* Remove member button */\n.member-remove-btn {\n  width: 28px;\n  height: 28px;\n  margin-left: auto;\n  border-radius: 50%;\n  border: 2px solid #8b2e0b;\n  background: linear-gradient(135deg, #c53030, #a02020);\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 900;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.member-remove-btn:hover {\n  background: linear-gradient(135deg, #a02020, #8b1a1a);\n  transform: scale(1.1);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n}\n\n.member-remove-btn:active {\n  transform: scale(0.95);\n}\n\n/* Mobile responsive */\n@media (max-width: 425px) {\n  .member-item {\n    border-width: 1px;\n    border-radius: 10px;\n  }\n\n  .member-item--empty {\n    padding: 8px 10px;\n  }\n\n  .member-icon {\n    width: 22px;\n    height: 22px;\n    font-size: 16px;\n    border-width: 1px;\n  }\n\n  .mi-avatar-wrap {\n    width: 32px;\n    height: 32px;\n    margin-left: 6px;\n  }\n\n  .mi-avatar-wrap::after {\n    width: 9px;\n    height: 9px;\n  }\n\n  .mi-role-badge {\n    width: 22px;\n    height: 22px;\n    font-size: 12px;\n    margin: 0 4px;\n  }\n\n  .mi-key-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .mi-avatar,\n  .mi-avatar img,\n  .mi-avatar .member-avatar-placeholder {\n    width: 32px;\n    height: 32px;\n  }\n\n  .mi-avatar .member-avatar-placeholder {\n    font-size: 12px;\n  }\n\n  .mi-content {\n    gap: 8px;\n    padding: 8px 10px 8px 0;\n  }\n\n  .member-name {\n    font-size: 13px;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1 1 auto;\n  }\n\n  .member-actions {\n    gap: 6px;\n  }\n\n  .member-action-btn {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    font-size: 12px;\n    border-width: 1px;\n    border: 2px solid #217021;\n    border-radius: 50%;\n    box-shadow: 0 1px 3px rgba(109, 76, 41, 0.25);\n    flex: 0 0 auto;\n  }\n\n  .member-action-text {\n    display: none;\n  }\n\n  .member-action-icon {\n    display: inline-block;\n    line-height: 1;\n  }\n\n  .member-remove-btn {\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n    border-width: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
